import {AmenitiesFiltersModal} from "./SerpAmenitiesFiltersModal";
import {WlTree} from "../../webcomponents/tree/tree";
import {WlModal} from "../../webcomponents/modal/modal.component";

export default class SerpFiltersModal {

    private readonly modal: WlModal

    private amenitiesFiltersModal: AmenitiesFiltersModal;

    constructor() {
        this.modal = document.querySelector<WlModal>('#js_filters-modal')!
        this.amenitiesFiltersModal = new AmenitiesFiltersModal(this.modal, [])
    }

    public init = (onSubmit: () => void) => {

        this.modal.querySelector(".js_filter-modal-button")?.addEventListener("wl-submit", onSubmit)
        this.setupEventListeners()

        const typesComponent: WlTree | null = document.querySelector(".js_modal-property-types")
        if (typesComponent) {
            typesComponent?.addEventListener("wl-select", () => this.amenitiesFiltersModal.manageVisibilityBasedOn(typesComponent.value))
            setTimeout(() => this.amenitiesFiltersModal.manageVisibilityBasedOn(typesComponent?.value), 0)
        }

    };

    changeAmenitiesVisibility = (propertyType: string[]) => {
        this.amenitiesFiltersModal.manageVisibilityBasedOn(propertyType)
    }

    private setupEventListeners = () => {
        let openButton = document.querySelectorAll('.js_open-filters-modal')
        if (this.modal) {
            openButton.forEach((button) => {
                button.addEventListener('click', () => this.modal.open())
            })
        }
    };
}
